import axios from "axios";

// 创建实例时设置 withCredentials
const axiosInstance = axios.create({
  withCredentials: true // ✅ 确保请求自动携带 HttpOnly Cookie
});

// 如果你有别的拦截器逻辑，也可以继续写
axiosInstance.interceptors.request.use(
  (config) => {
    // 这里通常不需要添加 Authorization header
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;